/**
 * Internal imports
 */
import body from './body';
import html from './html';
/**
 * Adds class to html and Body
 * @ignore
 * @param {string} state - CSS Class\es
 * @return {void}
 */
export default function addStateClass(state) {
    if (html)
        html.classList.add(state);
    if (body)
        body.classList.add(state);
}
